<template>
  <div class="container">
    <div class="head header">
      <img src="@/assets/back.png"
           style="margin: 10px"
           alt="返回"
           width="21"
           height="21"
           @click="go">
      <div>产品列表</div>
      <img src="@/assets/addRed.png"
           style="margin: 10px"
           width="21"
           height="21"
           @click="$router.push('/business/addProduct')" />
    </div>
    <van-search v-model="listQuery.query.name"
               @search="getList" placeholder="搜索商品名称或分类或状态，例如：电子商品" />

    <!-- 分类 -->
    <div class="tabs" v-if="tabList.length > 0">
      <div class="tab" v-for="(item,index) in tabList"
             :key="index">
          <div @click="handleTag(index,item.id)"
               :class="activeTag==index ? 'active':''">{{item.name}}</div>
      </div>
    </div>

    <div class="tabs row"
         style="background: #F6F6F6">
      <div class="tab"
             v-for="(item,index) in twoTabList"
             :key="index"
             style="color: #888988;margin-right: 13%;">
          <div @click="twoHandleTag(index)"
               :class="twoActiveTag==index ? 'active':''">{{item}}</div>
        </div>
    </div>

    <!-- 全部 -->
    <div v-if="state==0">
      <div class="contents" v-for="item in list">
        <div class="content">
          <img :src="item.image"
               width="98px"
               height="110px" />
          <div class="messages">
            <div class="title">{{item.name}}</div>
            <div class="mehint">{{item.packages}}</div>
            <div class="price">￥{{item.realPrice}}</div>
          </div>
        </div>
        <div class="shenhe">
          <img src="@/assets/edit.png"
               height="20"
               width="20"
               style="margin-left: 75%"
               @click="onJumpProInfo(item.id)"/>
          <div class="state" v-if="item.status == 0">待审核</div>
          <div class="state" v-if="item.status == 1">已通过</div>
          <div class="state" style="background: #666666" v-if="item.status == 2">已拒绝</div>
        </div>
      </div>
      <empty v-if="list.length==0"/>
    </div>
    <!-- 待审核 -->
    <div v-if="state==1">
      <div class="contents" v-for="item in applyList">
        <div class="content">
          <img :src="item.image"
               width="98px"
               height="110px" />
          <div class="messages">
            <div class="title">{{item.name}}</div>
            <div class="mehint">{{item.packages}}</div>
            <div class="price">￥{{item.realPrice}}</div>
          </div>
        </div>
        <div class="shenhe">
          <img src="@/assets/edit.png"
               height="20"
               width="20"
               style="margin-left: 75%"
               @click="$router.push('/business/editProduct')" />
          <div class="state" v-if="item.status == 0">待审核</div>
          <div class="state" v-if="item.status == 1">已通过</div>
          <div class="state" style="background: #666666" v-if="item.status == 2">已拒绝</div>
        </div>
      </div>
      <empty v-if="applyList.length==0"/>
    </div>

    <!-- 已审核 -->
    <div v-if="state==2">
      <div class="contents" v-for="item in yesList">
        <div class="content">
          <img :src="item.image"
               width="98px"
               height="110px" />
          <div class="messages">
            <div class="title">{{item.name}}</div>
            <div class="mehint">{{item.packages}}</div>
            <div class="price">￥{{item.realPrice}}</div>
          </div>
        </div>
        <div class="shenhe">
          <img src="@/assets/edit.png"
               height="20"
               width="20"
               style="margin-left: 75%"
               @click="$router.push('/business/editProduct')" />
          <div class="state" v-if="item.status == 0">待审核</div>
          <div class="state" v-if="item.status == 1">已通过</div>
          <div class="state" style="background: #666666" v-if="item.status == 2">已拒绝</div>
        </div>
      </div>
      <empty v-if="yesList.length==0"/>
    </div>

    <!-- 已拒绝 -->
    <div v-if="state==3">
      <div class="contents" v-for="item in noList">
        <div class="content">
          <img :src="item.image"
               width="98px"
               height="110px" />
          <div class="messages">
            <div class="title">{{item.name}}</div>
            <div class="mehint">{{item.packages}}</div>
            <div class="price">￥{{item.realPrice}}</div>
          </div>
        </div>
        <div class="shenhe">
          <img src="@/assets/edit.png"
               height="20"
               width="20"
               style="margin-left: 75%"
               @click="$router.push('/business/editProduct')" />
          <div class="state" v-if="item.status == 0">待审核</div>
          <div class="state" v-if="item.status == 1">已通过</div>
          <div class="state" style="background: #666666" v-if="item.status == 2">已拒绝</div>
        </div>
      </div>
      <empty v-if="noList.length==0"/>
    </div>

  </div>

</template>

<script>
import { getShopProductList, saveShopProduct,getShopCategoryList, getShopProductPage} from '@/api/product'
export default {
  name: "earnings",
  data () {
    return {
      value: '',
      show: true,
      activeTag: 0,
      twoActiveTag: 0,
      name : undefined,
      list : [],
      noList : [],
      yesList : [],
      applyList : [],
      listQuery: {
        page: 1,
        limit: 100000,
        query: {
          name: undefined,
          cid : undefined,
          source: 1,
          storeId : localStorage.getItem('storeId')
        }
      },
      state: 0,
      oneLoad : true,
      tabList: [],
      twoTabList: ['全部', '未审核', '已审核', '已拒绝'],
    }
  },
  created () {
    this.getList()
  },
  methods: {
    onJumpProInfo (pid) {
      this.$router.push({
        path:'/business/addProduct',
        query:{
          pid : pid
        }
      })
    },
    getList () {
      getShopProductPage(this.listQuery).then(response => {
        console.log(response)
        var applyList = []
        var yesList = []
        var noList = []
        var cates = []
        this.list = response.data.records
        var list = response.data.records
        for (var i = 0; i < list.length; i++) {
          if (list[i].status === 0) {
            applyList.push(list[i])
          } else if (list[i].status === 1) {
            yesList.push(list[i])
          } else if (list[i].status === 2) {
            noList.push(list[i])
          }
          cates.push({id : list[i].cid})
          if (this.oneLoad) {
            this.oneLoad = false
            this.getCateList(cates)
          }
        }
        this.applyList = applyList
        this.yesList = yesList
        this.noList = noList

      })
    },
    getCateList (params) {
      getShopCategoryList(params).then(response => {
        let tabList = []
        tabList.push({id : -1,name : '全部'})
        for (var i = 0; i < response.data.length; i++) {
          let tmp = response.data[i];
          let result = tabList.some(item=>{
            if(item.id===tmp.id){
              return true
            }
          })
          if(!result){
            tabList.push(tmp)
          }
        }
        this.tabList = tabList
      })
    },
    handleTag (index,cid) {
      this.activeTag = index;
      if (index == 0) {
        this.show = true
      } else {
        this.show = false
      }
      if (cid > -1) {
        this.listQuery.query.cid = cid
      } else {
        this.listQuery.query.cid = undefined
      }
      this.getList()
    },
    twoHandleTag (index) {
      this.twoActiveTag = index;
      if (index == 0) {
        this.state = 0
      } else if (index == 1) {
        this.state = 1
      } else if (index == 2) {
        this.state = 2
      } else {
        this.state = 3
      }
    },
    go () {
      this.$router.go(-1);
    },
    withdraw () {
      this.$router.push("/withdraw")
    }
  }
};
</script>
<style lang="less" scoped>
  .active {
    color: #fe003b;
    border-bottom: 3px solid #fe003b;
  }
.container {
  padding-top: 50px;
  .head {
    background-color: #f3f3f3;
    height: 44px;
    line-height: 44px;
    opacity: 1;
    display: flex;
    justify-content: space-between;
  }
  .tabs {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 44px;
    line-height: 44px;
    padding: 0 12px;
    overflow-x: scroll;
    -webkit-backface-visibility: hidden;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }
    .tab {
      height: 25px;
      line-height: 25px;
      padding: 0 0.4rem;
      white-space: nowrap;
      font-size: 14px;
      font-weight: bold;
      cursor: pointer;
      &.active {
        color: #fe003b;
        border-bottom: 3px solid #fe003b;
      }
    }
  }
  .contents {
    margin-top: 12px;
    padding-left: 12px;
    padding-right: 12px;
    padding-bottom: 12px;
    border-bottom: 2px solid #ededed;
    .content {
      display: flex;
      flex-direction: row;
      .messages {
        margin-left: 10%;
        .title {
          min-height: 47px;
          font-size: 13px;
          font-family: PingFang SC;
          font-weight: 400;
          line-height: 18px;
          color: rgba(51, 51, 51, 1);
          opacity: 1;
          overflow: hidden;
          word-wrap: break-word;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          flex: 1;
        }
        .price {
          font-size: 16px;
          font-family: DIN;
          font-weight: bold;
          line-height: 17px;
          color: rgba(254, 0, 59, 1);
          opacity: 1;
          margin-top: 15%;
        }
        .mehint {
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 400;
          line-height: 17px;
          color: rgba(153, 153, 153, 1);
          opacity: 1;
        }
      }
    }
    .shenhe {
      display: flex;
      margin-top: 6px;
      .state {
        height: 20px;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 20px;
        color: rgba(255, 255, 255, 1);
        opacity: 1;
        background: red;
        padding-left: 5px;
        padding-right: 5px;
        border-radius: 4px;
        margin-left: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/business/product/list.vue